import React from 'react';
import { Award, CheckCircle2, Shield, Truck } from 'lucide-react';

const benefits = [
  {
    title: 'Thoroughly Inspected',
    description: 'Every appliance undergoes rigorous testing and certification',
    icon: CheckCircle2,
  },
  {
    title: 'Great Value',
    description: 'Quality appliances at competitive prices',
    icon: Award,
  },
  {
    title: 'Fast Delivery',
    description: 'Professional delivery and installation available',
    icon: Truck,
  },
  {
    title: 'Satisfaction Guaranteed',
    description: '30-day money-back guarantee on all purchases',
    icon: Shield,
  },
];

export function HomeBenefitsSection() {
  return (
    <section className="overflow-hidden bg-gray-50 py-16 sm:py-20">
      <div className="container mx-auto px-4">
        <div className="mb-9 text-center sm:mb-11">
          <div className="mb-3 flex items-center justify-center gap-4 text-xs font-black uppercase tracking-[0.2em] text-blue-700 sm:text-sm">
            <span className="h-0.5 w-10 bg-yellow-400" />
            Vholic Appliances
            <span className="h-0.5 w-10 bg-yellow-400" />
          </div>
          <h2 className="text-3xl font-black tracking-tight text-slate-950 sm:text-4xl lg:text-5xl">
            Built for Peace of Mind
          </h2>
        </div>

        <div className="overflow-hidden rounded-[2rem] border border-blue-200 bg-white shadow-[0_22px_60px_rgba(30,64,175,0.12)]">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4">
            {benefits.map(({ title, description, icon: Icon }, index) => (
              <div
                key={title}
                className={`relative flex min-h-[270px] flex-col items-center justify-center px-6 py-9 text-center sm:px-7 ${
                  index > 0 ? 'border-t border-blue-100 sm:border-t-0' : ''
                } ${index % 2 === 1 ? 'sm:border-l' : ''} ${
                  index >= 2 ? 'sm:border-t lg:border-t-0' : ''
                } ${index > 0 ? 'lg:border-l' : ''}`}
              >
                <div className="mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-blue-50 ring-8 ring-blue-50/50">
                  <Icon className="h-10 w-10 text-blue-700" strokeWidth={1.8} aria-hidden="true" />
                </div>

                <h3 className="text-xl font-extrabold text-slate-900">{title}</h3>
                <span className="my-4 h-1 w-7 rounded-full bg-yellow-400" />
                <p className="max-w-[250px] text-sm leading-6 text-slate-600 sm:text-base">
                  {description}
                </p>
              </div>
            ))}
          </div>

          <div className="flex flex-col items-center justify-center gap-2 bg-gray-900 px-6 py-4 text-center text-white sm:flex-row sm:gap-5">
            <div className="flex items-center gap-2 text-sm font-medium">
              <Shield className="h-5 w-5 text-yellow-300" aria-hidden="true" />
              Trusted Appliances. Exceptional Service.
            </div>
            <span className="hidden h-5 w-px bg-white/35 sm:block" />
            <span className="text-sm font-extrabold">Vholic Appliances</span>
          </div>
        </div>
      </div>
    </section>
  );
}
